<div class="content-container">
	<div id="coming-soon" fxLayout="column" fxLayoutAlign="center center" [@animate]="{value:'*',params:{duration:'600ms',y:'100px', delay:'10ms'}}">

		<img src="assets/coming-soon.png" alt="Coming Soon!">

	</div>
</div>
